/**
 * Polyfill for Element APIs for IE11
 * from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */

const applyPolyfills = () => {
    if (!(Element.prototype as any).matches) {
        Element.prototype.matches =
            (Element.prototype as any).msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!(Element.prototype as any).closest) {
        Element.prototype.closest = function (s) {
            var el = this;

            do {
                if (Element.prototype.matches.call(el, s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }
};

export default applyPolyfills;
